export default import.meta.ROLLUP_FILE_URL_Cz5AYrd$;